import type { ChatEntityMetadata } from "../interfaces/chat"

export function compareChatTimestamp(
    a: ChatEntityMetadata,
    b: ChatEntityMetadata,
): number {
    if (a.derivedTimestamp === b.derivedTimestamp) {
        if (a.timeReceived === b.timeReceived) {
            return 0
        }
        return a.timeReceived - b.timeReceived
    }
    return a.derivedTimestamp - b.derivedTimestamp
}

export function copyChatTimestamp<T extends ChatEntityMetadata>(
    source: ChatEntityMetadata | undefined,
    target: T,
): T {
    return {
        ...target,
        derivedTimestamp: source?.derivedTimestamp ?? 0,
        timeReceived: Date.now(),
    }
}
